import Basic from '@/components/page/Basic.js'
import { Config,Penanggalan,AxiosWithJar, FuelColor, Rainbow, Rainbow2 } from '@/utility.js'

export default{
	extends: Basic,
	props:["plant", "station"],
	data:()=>({
		spbu:{ data:{}, list:[], types:[] },
		sales: {hourly:[], weekly:[], lastTrans:[]},
		ytd: {raw:{}, sales:[], losses:[], bbk:[], cash:[], noncash:[], pctcash:[],rekap:[],},
		stock:{ tank:[] },
		critical:{product:[], area:[], region:[] },
		loading: {
			table:true,
			tankstock: true,
		},

		aftertitlestock:[], //this for additional tooltip every bar chart data
	}),
	computed:{
	},
	methods:{

		async loadStationData(id) {
			let url = Config().apiURL + "/fuel2/station?" + (this.plant ? "&plant=" + this.plant : "") + (this.station ? "&station=" + this.station : "") + (id ? "&station=" + id : "");
			await AxiosWithJar().get(url).then(result=>{
				if(result.data.data.length){
					this.spbu.data = result.data.data[0];
				}
			})
		},

		async loadStationList(type='') {
			let url = Config().apiURL + "/fuel2/station?"  + (type ? "&type=" + type : "") + (this.plant ? "&plant=" + this.plant : "") + (this.station ? "&station=" + this.station : "");
			await AxiosWithJar().get(url).then(result=>{
				if(result.data.data.length){
					this.spbu.list = result.data.data;
				}
			})
		},

		async loadStationTypes() {
			let url = Config().apiURL + "/fuel2/station?detail=type" + (this.plant ? "&plant=" + this.plant : "") + (this.station ? "&station=" + this.station : "");
			await AxiosWithJar().get(url).then(result=>{
				if(result.data.data.length){
					this.spbu.types = result.data.data;
				}
			})
		},

		async loadSalesHourly(){
			let url = Config().apiURL+ "/ptm/salesHourly?" + (this.plant ? "&plant=" + this.plant : "") + (this.station ? "&spbu=" + this.station : "") +
				"&dtstart=" + Penanggalan().sekarang + "&dtend=" + Penanggalan().sekarang;
			await AxiosWithJar().get(url).then(result=>{
				if(result.data){
					this.sales.hourly = this.processBarChart2(result.data, 'grade_name_std', 'delivery_volume', false, 'completed_ts', 1000, 2, FuelColor,
						false, false, false, true, function (x) { return x.replace("_", " "); }, false, function (x) { const d = new Date(x); return d.getHours(); })
					//console.log(this.sales.hourly)
				}
			})
		},

		async loadLastTrans(count){
			let url = Config().apiURL+ "/ptm/lastTrans?" + (this.plant ? "&plant=" + this.plant : "") + (this.station ? "&spbu=" + this.station : "") +
				"&dtstart=" + Penanggalan().sekarang + "&dtend=" + Penanggalan().sekarang+ "&count=" + count;
			await AxiosWithJar().get(url).then(result=>{
				if(result.data){
					this.sales.lastTrans = result.data;
					//console.log(result.data)
				}
			})
		},

		async loadYTD(){
			let url = Config().apiURL+ "/fuel2/ytd?" + (this.plant ? "&plant=" + this.plant : "") + (this.station ? "&station=" + this.station : "");
			await AxiosWithJar().get(url).then(result=>{
				if(result.data){
					this.ytd = {
						raw: result.data,
						sales: this.processYTD(result.data.summary, "Info", "SalesVolume", false, "Grup", 1000, 0),
						losses: this.processYTD(result.data.summary, "Info", "LossesVolume", "SalesVolume", "Grup", 0.01, 2),
						bbk: this.processYTD(result.data.summary, "Info", "SalesVolumeBBK", "SalesVolumeAll", "Grup", 0.01, 2),
						cash: this.processYTD(result.data.cash, "Info", "AmountCash", false, "Grup", 1, 2),
						noncash: this.processYTD(result.data.cash, "Info", "AmountNonCash", false, "Grup", 1, 2),
						pctcash: this.processYTD(result.data.cash, "Info", "AmountCash", "AmountAll", "Grup", 0.01, 2),
						rekap: this.processYTD(result.data.unit, "Info", "TotalUnit", false, "Grup", 1, 2),
					};


				}
			})
		},

		async loadSalesYTD(){
			let url =Config().apiURL+"/fuel2/sales?period=daily&detail=product"
				url += "&date-range-start="+Penanggalan().mingguSekarang
				url += "&date-range-end="+Penanggalan().kemarin
				url += (this.plant ? "&plant=" + this.plant : "") + (this.station ? "&station=" + this.station : "");
			await AxiosWithJar().get(url).then(result=>{
				if(result.data.data){
					this.sales.weekly = this.processBarChart2(result.data.data, 'ProductName', 'SalesVolume', false, 'Period', 1000, 2, FuelColor,
						false, false, false, true, false, false, false, true)
				}
			})
		},

		async loadCritical(satgas=0){
			let url =Config().apiURL+"/fuel2/stock?satgas=" +satgas +"&status=CRITICAL&detail=product" + (this.plant ? "&plant=" + this.plant : "") + (this.station ? "&station=" + this.station : "");
			await AxiosWithJar().get(url).then(result=>{
				if(result.data.data){
					this.critical.product = result.data.data;
				}
			})

			/*
			//Change to Region below
			url =Config().apiURL+"/fuel2/stock?status=CRITICAL&detail=area" + (this.plant ? "&plant=" + this.plant : "") + (this.station ? "&station=" + this.station : "");
			await AxiosWithJar().get(url).then(result=> {
				if(result.data.data) {
					this.critical.area = result.data.data;
				}
			})
			*/

			url =Config().apiURL+"/fuel2/stock?view=overview&status=CRITICAL&detail=region" + (this.plant ? "&plant=" + this.plant : "") + (this.station ? "&station=" + this.station : "");
			await AxiosWithJar().get(url).then(result=> {
				if(result.data.data) {
					this.critical.region = result.data.data;
				}
			})
		},

		async loadStockSatgasByArea() {
			let url = Config().apiURL + "/bright/stock"
			await AxiosWithJar().get(url).then(result => {
				if (result.data.area.length) {
					this.stock.area = result.data.area;
					this.stock.div = result.data.div;
					this.stock.dept = result.data.dept;
					this.stock.divchart = this.processBarChart(result.data.areadiv, "SalesArea", "AREA ", 'StockValue', false, 'DivisiName', '', 1000000, 2, Rainbow);
					this.stock.deptchart = this.processBarChart(result.data.areadept, "SalesArea", "AREA ", 'StockValue', false, 'DepartmentName', '', 1000000, 2, Rainbow);
					this.stock.agingarea = this.processBarChart(result.data.agingarea, 'Kriteria', '', 'StockValue', false, "SalesArea", "AREA ", 1000000, 2, Rainbow2);
					this.stock.agingdiv = this.processBarChart(result.data.agingdiv, 'Kriteria', '', 'StockValue', false, "DivisiName", "", 1000000, 2, Rainbow2);
					this.stock.notsoldarea = this.processBarChart(result.data.notsoldarea, 'Kriteria', '', 'StockValue', false, "SalesArea", "AREA ", 1000000, 2, Rainbow2);
					this.stock.notsolddiv = this.processBarChart(result.data.notsolddiv, 'Kriteria', '', 'StockValue', false, "DivisiName", "", 1000000, 2, Rainbow2);
				}
			})
		},

		async loadCriticalSatgas(){
			let url =Config().apiURL+"/fuel2/stocksatgas?satgas=1&status=CRITICAL&detail=product" + (this.plant ? "&plant=" + this.plant : "") + (this.station ? "&station=" + this.station : "");
			await AxiosWithJar().get(url).then(result=>{
				if(result.data.data){
					this.critical.product2 = result.data.data;
				}
			})
			url =Config().apiURL+"/fuel2/stocksatgas?status=CRITICAL&detail=area" + (this.plant ? "&plant=" + this.plant : "") + (this.station ? "&station=" + this.station : "");
			await AxiosWithJar().get(url).then(result=>{
				if(result.data.data){
					this.critical.area2 = result.data.data;
				}
			})
		},

		async loadPlantSatgas(plant, station) {
			let url = Config().apiURL + "/plant/plantSatgas?" + (plant ? "&plantno=" + plant : "") + (station ? "&stationid=" + station : "");
			await AxiosWithJar().get(url).then(result=>{
				if(result.data.length){
					this.plant = result.data[0];
				}
			})
		},

		async loadTankStock(satgas=0){
			let url =Config().apiURL+"/fuel2/tankstock?satgas=" +satgas + (this.plant ? "&plant=" + this.plant : "") + (this.station ? "&station=" + this.station : "");
			await AxiosWithJar().get(url).then(result=>{
				if(result.data.data){
					this.stock.tank = result.data.data;

					for (let i=0;i<this.stock.tank.length;i++) {
						//for additional tooltip info
						let tooltipitem = [];
						tooltipitem.push("Status: "+this.stock.tank[i].StatusATG);
						tooltipitem.push("Last Update: "+this.stock.tank[i].LastUpdate2);
						this.aftertitlestock.push(tooltipitem);
					}
				}
			})
			.catch(error => {
				//console.log('err: ' + error)
			})
			.finally(() => {
				this.loading.tankstock = false;
			})
		},

		getLastDayOfMonth(year, month) {
            const nextMonth = new Date(year, month, 0);
            return year + '-' + (month) + '-' + nextMonth.getDate();
        },

		getMonthName(monthNumber) {
			let months = ['Januari','Februari','Maret','April','Mei','Juni','Juli','Agustus','September','Oktober','November','Desember']
			return months[monthNumber -1]
		}
	}
}
